/** VistoeraTASK-00333 / 00341 — collapsed vs expanded asset-input handle presentation. */

export type GenerateImageAssetDropState = 'none' | 'candidate' | 'incompatible' | 'reference-limit'

/** Visual anchor for every expanded related-assets edge (TASK-00341). */
export const RELATED_ASSET_SLOT_AGGREGATE_POSITION = 'slot-left-center' as const

export function resolveGenerateImageInputHandleVisibility(
  showExpanded: boolean,
  _relatedAssetsOpen: boolean,
): {
  showCollapsedStandardInputHandle: boolean
  /** @deprecated Per-thumbnail handles — always false after TASK-00341. */
  showExpandedRelatedAssetHandles: boolean
  showLegacyHiddenReferenceAnchors: boolean
  showExpandedSectionAggregateHandle: boolean
  /** Per-edge `image-ref-in::<edgeId>` handles stacked at slot left-center (expanded only). */
  showExpandedSlotStackedPerEdgeHandles: boolean
} {
  return {
    showCollapsedStandardInputHandle: !showExpanded,
    showExpandedRelatedAssetHandles: false,
    showLegacyHiddenReferenceAnchors: !showExpanded,
    showExpandedSectionAggregateHandle: showExpanded,
    showExpandedSlotStackedPerEdgeHandles: showExpanded,
  }
}

export function relatedAssetsDropZoneClassName(
  showExpanded: boolean,
  dropState: GenerateImageAssetDropState,
  materialCount: number,
): string {
  if (!showExpanded) return ''
  if (dropState === 'candidate') return ' is-drop-candidate'
  if (dropState === 'incompatible' || dropState === 'reference-limit') return ' is-drop-incompatible'
  if (materialCount > 0) return ' is-filled'
  return ''
}
